export default "__VITE_ASSET__B5XIvtH1__"